/**
 * FollowUpsStandalone - rota própria /followups (com NavSidebar).
 *
 * A FollowUpsPage também é renderizada DENTRO do shell do inbox (currentPage
 * 'followups'), mas o badge de follow-up do ChatWindow abre `/followups?id=<id>`
 * em nova aba para "Ver detalhes". Sem uma rota /followups real, isso caía no
 * catch-all (SmartRedirect) e só voltava pro inbox. Este wrapper dá a rota e o
 * deep-link `?id=` (tratado na própria FollowUpsPage) passa a abrir o detalhe.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import NavSidebar from '../../components/NavSidebar';
import FollowUpsPage from './FollowUpsPage';

const FollowUpsStandalone = () => {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const { user } = useAuth();
  const isBusinessChannel = user?.default_channel === 'wa_business';

  // Mesmo padrão das outras páginas standalone (CampaignsPage): rotas próprias
  // navegam direto; o resto cai no shell do inbox via targetPage.
  const handlePageChange = (page) => {
    if (page === 'followups') return;
    const standaloneRoutes = {
      'meta-leads': '/meta-leads',
      'saved-messages': '/saved-messages',
      'campaigns': '/campaigns',
      'empresa': '/empresa',
    };
    if (standaloneRoutes[page]) {
      navigate(standaloneRoutes[page]);
      return;
    }
    navigate(isBusinessChannel ? '/wa-business' : '/inbox', {
      state: { targetPage: page },
    });
  };

  return (
    <div style={{
      display: 'flex',
      height: '100vh',
      width: '100vw',
      overflow: 'hidden',
      backgroundColor: colors.bgSecondary,
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    }}>
      <NavSidebar currentPage="followups" onPageChange={handlePageChange} />
      <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
        <FollowUpsPage />
      </div>
    </div>
  );
};

export default FollowUpsStandalone;
